/**
 * Registry of custom interface module components.
 * Maps componentKey strings (from the database) to lazy-loaded React components.
 *
 * Entries in CUSTOM_MODULE_REGISTRY are auto-generated from nucleus.module.ts manifests.
 * Do not edit _generated-registry.ts directly — run `make generate-modules` instead.
 *
 * See docs/ARCHITECTURE.md §11 "Custom Module System" for the full authoring guide.
 */
import type { CustomModuleProps } from "@nucleus/shared-types";
import { type ComponentType, type LazyExoticComponent } from "react";

import { GENERATED_MODULE_REGISTRY } from "./_generated-registry.js";

// Re-export for consumers that import from this file
export type { CustomModuleProps };

type LazyCustomModule = LazyExoticComponent<ComponentType<CustomModuleProps>>;

/**
 * Registry mapping componentKey values to lazy-loaded React components.
 * Keys must match the componentKey field stored in the modules table.
 * Entries are auto-generated from nucleus.module.ts manifests via `pnpm generate:modules`.
 */
export const CUSTOM_MODULE_REGISTRY: Record<string, LazyCustomModule> = {
	...GENERATED_MODULE_REGISTRY,
};

/**
 * Look up a custom module component by its componentKey.
 * Returns undefined if the key is not registered.
 * @param componentKey - the registry key matching the modules.componentKey DB field
 */
export function getCustomModuleComponent(componentKey: string): LazyCustomModule | undefined {
	return CUSTOM_MODULE_REGISTRY[componentKey];
}

/**
 * Returns the list of all registered custom module component keys.
 * Used by admin UI to show available custom modules for selection.
 */
export function getRegisteredModuleKeys(): string[] {
	return Object.keys(CUSTOM_MODULE_REGISTRY);
}

/**
 * Converts a component key (kebab-case) into a human-readable display name.
 * Example: "ad-builder-project-board" -> "Ad Builder Project Board"
 * @param key - the component key string
 */
export function formatComponentKeyAsName(key: string): string {
	return key
		.split("-")
		.map((word) => word.charAt(0).toUpperCase() + word.slice(1))
		.join(" ");
}
